import { motion } from "framer-motion";
import { useLanguage } from "@/contexts/LanguageContext";
import { fadeUpVariants, revealTransition, revealViewport } from "@/lib/motion";
import { AnimatedCounter } from "@/components/AnimatedCounter";

const avatars = [
  "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&fit=crop&crop=faces&fm=webp&q=70",
  "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&h=80&fit=crop&crop=faces&fm=webp&q=70",
  "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&h=80&fit=crop&crop=faces&fm=webp&q=70",
  "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=80&h=80&fit=crop&crop=faces&fm=webp&q=70",
];

// Static marketing count - no database query needed
// This prevents exposing real-time signup metrics to competitors
const MARKETING_COUNT = 100;

export function ValidationBar() {
  const { t } = useLanguage();

  const displayCount = MARKETING_COUNT;
  const extraCount = displayCount > 4 ? displayCount - 4 : 0;

  return (
    <section className="py-16 border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={revealViewport}
          variants={fadeUpVariants}
          transition={revealTransition}
          className="flex flex-col md:flex-row items-center justify-center gap-8"
        >
          {/* Beta Testers */}
          <div className="flex items-center gap-4">
            <div className="flex -space-x-3">
              {avatars.map((avatar, i) => (
                <div
                  key={i}
                  className="relative"
                >
                  <img
                    src={avatar}
                    alt={`Beta tester ${i + 1}`}
                    loading="lazy"
                    decoding="async"
                    className="w-10 h-10 rounded-full border-2 border-background object-cover"
                  />
                </div>
              ))}
              {extraCount > 0 && (
                <div
                  className="w-10 h-10 rounded-full bg-lime/20 border-2 border-background flex items-center justify-center"
                >
                  <span className="text-xs font-bold text-lime">+{extraCount}</span>
                </div>
              )}
            </div>
            <span className="text-sm text-muted-foreground">
              <span className="font-semibold text-foreground">
                <AnimatedCounter to={displayCount} />+
              </span>{" "}
              {t('validation.onWaitlist')}
            </span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
